import { useEffect, useState, useCallback } from 'react'
import { useAppSelector } from '../../utils/redux/store'
import { getSongUrl } from '../../utils/tools'
import { Howl } from 'howler'
import { Song } from '../../utils/redux/songsSlice'

export function useHowlPlayer() {
  const { token } = useAppSelector((state) => state.auth)
  const [queue, setQueue] = useState<Song[]>([])
  const [howl, setHowl] = useState<Howl | undefined>(undefined)

  useEffect(() => {
    if (!queue.length) return
    const queueSongUrls = queue.map((song) => getSongUrl(song))
    const _howl = new Howl({
      src: queueSongUrls,
      onloaderror: (id, error) => {
        console.error('Error loading audio:', error)
      },
      onplayerror: (id, error) => {
        console.error('Error playing audio:', error)
      },
      xhr: {
        method: 'GET',
        headers: { Authorization: 'Bearer ' + token },
      },
    })
    setHowl(_howl)
    return () => {
      _howl.unload()
    }
  }, [queue, token])

  return {
    howl,
    setQueue,
  }
}